module.exports = __webpack_public_path__ + "static/media/projects-b.34d90675.svg";